import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FoundingVisionSection from './components/FoundingVisionSection';
import TeamExpertiseSection from './components/TeamExpertiseSection';
import PhilosophySection from './components/PhilosophySection';
import MethodologySection from './components/MethodologySection';
import TestimonialsSection from './components/TestimonialsSection';
import OpenSourceContributionsSection from './components/OpenSourceContributionsSection';
import TimelineSection from './components/TimelineSection';
import CallToActionSection from './components/CallToActionSection';

const AboutAICleanCore = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>About AI Clean Core - Champions of AI Independence | Enterprise AI Consulting</title>
        <meta 
          name="description" 
          content="Learn about AI Clean Core's mission to help enterprises achieve AI independence through open-source solutions. Meet our expert team and discover our proven methodology for breaking free from vendor lock-in." 
        />
        <meta name="keywords" content="AI Clean Core, about us, AI independence, open source AI, enterprise AI consulting, vendor lock-in, AI transformation" />
        <meta property="og:title" content="About AI Clean Core - Champions of AI Independence" />
        <meta property="og:description" content="Discover how AI Clean Core helps enterprises reclaim control over their AI destiny through open-source innovation and internal capability building." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/about-ai-clean-core" />
      </Helmet>
      <Header />
      <main className="pt-16 lg:pt-20">
        <HeroSection />
        <FoundingVisionSection />
        <TeamExpertiseSection />
        <PhilosophySection />
        <MethodologySection />
        <TestimonialsSection />
        <OpenSourceContributionsSection />
        <TimelineSection />
        <CallToActionSection />
      </main>
      <footer className="bg-text-primary text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-brand-primary to-brand-secondary rounded-lg flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-5 h-5 text-white" fill="currentColor">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <span className="text-xl font-bold">AI Clean Core</span>
            </div>
            <p className="text-gray-400 mb-4">
              Empowering enterprises to achieve AI independence through open-source innovation
            </p>
            <p className="text-gray-500 text-sm">
              © {new Date()?.getFullYear()} AI Clean Core. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutAICleanCore;